var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80469 0.529297C9.35697 0.529297 9.80469 0.977012 9.80469 1.5293V7.5293H15.8047C16.357 7.5293 16.8047 7.97701 16.8047 8.5293C16.8047 9.08158 16.357 9.5293 15.8047 9.5293H9.80469V15.5293C9.80469 16.0816 9.35697 16.5293 8.80469 16.5293C8.2524 16.5293 7.80469 16.0816 7.80469 15.5293V9.5293H1.80469C1.2524 9.5293 0.804688 9.08158 0.804688 8.5293C0.804688 7.97701 1.2524 7.5293 1.80469 7.5293H7.80469V1.5293C7.80469 0.977012 8.2524 0.529297 8.80469 0.529297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.a34992b80207e835c6cb7c11a5f4f5f2.svg";
export { ForwardRef as ReactComponent };